import { EnvironmentControl } from "@excellent/ui/blocks/excellent/environments/environment-control";
import { useCanonicalEnvironmentOptional } from "./canonical-environment-provider";

/** Uses the one shared, authorized context request. */
export function EnvIndicator({
  onNavigate = (href) => window.location.assign(href),
}: { onNavigate?: (href: string) => void } = {}) {
  const context = useCanonicalEnvironmentOptional();
  return (
    <EnvironmentControl
      response={context?.response ?? null}
      failed={Boolean(context?.error)}
      invalidRoute={context?.invalidRoute}
      onSelect={(subject) => context?.select({ kind: "environment", subject })}
      onSelectAll={() => context?.select({ kind: "all" })}
      onRefresh={() => {
        void context?.refresh().catch(() => {});
      }}
      onLoadMore={() => {
        void context?.loadMore().catch(() => {});
      }}
      onNavigate={onNavigate}
    />
  );
}
